import { MsalAuthProvider, LoginType } from 'react-aad-msal'
import { environment } from './config'

// Msal Configurations
const config = {
  auth: {
    authority: `https://login.microsoftonline.com/${environment.auth.tenant}`,
    clientId: environment.auth.clientId,
    redirectUri: environment.auth.redirectUri
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
}

// Authentication Parameters
const authenticationParameters = {
  scopes: [`api://${environment.auth.clientId}/access_as_user`]
}

// Options
const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin
}

export const authProvider = new MsalAuthProvider(
  config,
  authenticationParameters,
  options
)

export const getAuthenticatedUserName = () => {
  return authProvider?.getAccountInfo()?.account?.userName ?? ""
}
